import React from 'react'
import styled from 'styled-components'
import { useInboxHandlers } from '../../../../../services/actions/inbox/useInboxHandlers'

interface IDeleteConversationModalProps {
    conversationId: string
    conversationExistsOnLinkedIn?: boolean
    onClose: () => void
}

const DeleteConversationModal: React.FC<IDeleteConversationModalProps> = ({ conversationId, conversationExistsOnLinkedIn, onClose }) => {
    const { deleteConversationHandler } = useInboxHandlers()

    return (
        <Overlay onClick={onClose}>
            <Modal onClick={e => e.stopPropagation()}>
                <Title>Delete Conversation</Title>
                <Description>
                    Are you sure you want to delete this conversation? This action cannot be undone.
                    {conversationExistsOnLinkedIn && ' The conversation will also be deleted from LinkedIn.'}
                </Description>
                <Actions>
                    <CancelBtn onClick={onClose}>Cancel</CancelBtn>
                    <DeleteBtn onClick={() => deleteConversationHandler(conversationId, !!conversationExistsOnLinkedIn)}>
                        Delete
                    </DeleteBtn>
                </Actions>
            </Modal>
        </Overlay>
    )
}

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`
const Modal = styled.div`
    background: white;
    border-radius: 12px;
    padding: 28px 32px;
    max-width: 420px;
    width: 90%;
    box-shadow: 0 8px 32px rgba(0,0,0,0.16);
`
const Title = styled.h3`
    font-size: 18px;
    font-weight: bold;
    color: #333951;
    margin: 0 0 12px;
`
const Description = styled.p`
    font-size: 14px;
    color: #545e77;
    line-height: 1.6;
    margin: 0 0 24px;
`
const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
`
const CancelBtn = styled.button`
    padding: 8px 20px;
    border-radius: 8px;
    border: 1px solid #dae0e8;
    background: white;
    font-size: 14px;
    cursor: pointer;
    color: #545e77;
    &:hover { background: #f6f8fb; }
`
const DeleteBtn = styled.button`
    padding: 8px 20px;
    border-radius: 8px;
    border: none;
    background: #ff6760;
    color: white;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    &:hover { background: #ff4f47; }
`

export default DeleteConversationModal
